/*
 * Copyright (c) 2020. American Express Company
 */

import React, { Component, ReactComponentElement } from 'react';

// models and services
import { CardModel } from 'src/types/card.model';
import FinanceService, { CanAffordPurchase } from '../../services/finance.service';
import FormatService from '../../services/format.service';

// components
import BwSlider from '../bw-slider/BwSlider';
import GoalDrawer from './GoalDrawer';
import Output from '../atomic/molecules/output/Output';

// icons and styles
import { ReactComponent as CareForFamilyIcon } from 'src/bw/goal/care-for-family.svg';

export default class MonthlyExpenseDrawer extends Component<any> {
    public override render(): ReactComponentElement<any> {
        const drawerProps: any = this.props.drawerProps;
        const card: CardModel = drawerProps.card;

        if (!card.attributes.monthly) {
            card.attributes.monthly = 0;
        }

        let intro: JSX.Element = null;
        let icon: JSX.Element = null;

        switch (card.description) {
            case 'care for a family member':
                intro = (
                    <span>
                        Plan for the unexpected cost of taking care of family members by adding a recurring monthly
                        expense to your financial plan.
                    </span>
                );
                icon = <CareForFamilyIcon />;
                break;
        }

        const canAfford: CanAffordPurchase = FinanceService.canAffordMonthly(
            card.startDate,
            card.endDate,
            card.attributes.monthly,
            (card as any).monthlySavings,
            (card as any).monthlyFreeCash
        );

        return (
            <GoalDrawer
                drawerProps={drawerProps}
                handleBack={this.props.handleBack}
                handleChangeCard={this.props.handleChangeCard}
                handleUpdateCard={this.props.handleUpdateCard}
                handleDeleteCard={this.props.handleDeleteCard}
                showLoader={this.props.showLoader}
                hideLoader={this.props.hideLoader}
                icon={icon}
                introContent={intro}
                cashFlow={this.props.user.cashFlow}
                handleChangeCardDate={this.props.handleChangeCardDate.bind(this)}
                hasEndDate
            >
                <Output
                    title="Planning for monthly care cost of:"
                    main={FormatService.format(Number(card.attributes.monthly))}
                    canAfford={canAfford}
                />

                <BwSlider
                    id="slider"
                    label="Adjust care costs"
                    value={Number(card.attributes.monthly)}
                    formattedValue={FormatService.formatCompactMoney(Number(card.attributes.monthly))}
                    step={100}
                    min={0}
                    max={10000}
                    onChange={(value: any) => this.props.handleChangeCardAttribute(card, value, 'monthly', 'number')}
                    inputToggleText="Add a precise amount"
                    isCurrency
                />
            </GoalDrawer>
        );
    }
}
